import {
    AdvancedSettingsPanel,
    LimitedAdvancedSettings,
} from 'apps/studio/components/settings/fields/Base/advanced'
import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const ForceAccuracy = {
    label: 'Force Accuracy',
    tooltip: `If the mobile app doesn't get the accurate location before timing out, no location will be captured.`,
    settingType: 'toggleInput',
    property: 'gps_accuracy_required',
}

//TODO: validation
export const Accuracy = {
    label: 'Accuracy(m)',
    settingType: 'textInput',
    property: 'gps_accuracy',
    validation: ({ gps_accuracy }) => {
        return {
            errors: gps_accuracy && isNaN(gps_accuracy) && 'Must be a number',
        }
    },
    additionalProps: {
        maxLength: 7,
    }
}

//TODO: validation
export const AccuracyTimeout = {
    label: 'Timeout(ms)',
    settingType: 'textInput',
    property: 'gps_timeout',
    validation: ({ gps_timeout }) => {
        return {
            errors: gps_timeout && isNaN(gps_timeout) && 'Must be a number',
        }
    },
    additionalProps: {
        maxLength: 7,
    }
}

export const AdvancedPanel = AdvancedSettingsPanel([
    SettingsLabel('Config'),
    Accuracy,
    AccuracyTimeout,
    ForceAccuracy,
    ...LimitedAdvancedSettings,
])
